document.addEventListener("DOMContentLoaded", function() {

  const sliders = document.querySelectorAll("[data-slider]");

  sliders.forEach(slider => {

    const track = slider.querySelector("[data-slider-track]");
    const slides = slider.querySelectorAll(".pg-slide");
    const next = slider.querySelector("[data-next]");
    const prev = slider.querySelector("[data-prev]");

    let index = 0;

    function isMobile() {
      return window.innerWidth <= 768;
    }

    function updateSlide() {
      if (isMobile()) return; // 🔥 NÃO aplica transform no mobile
      track.style.transform = `translateX(-${index * 100}%)`;
    }

    window.addEventListener("resize", updateSlide);

    next?.addEventListener("click", () => {
      if (isMobile()) return;
      index = (index + 1) % slides.length;
      updateSlide();
    });

    prev?.addEventListener("click", () => {
      if (isMobile()) return;
      index = (index - 1 + slides.length) % slides.length;
      updateSlide();
    });

    updateSlide();

  });

});

